import { useCallback } from 'react';

export function safeScrollTo (element, top, behavior) {
    if (!element) {
        return;
    }

    if (typeof element.scrollTo === 'function') {
        element.scrollTo({ top, behavior });
        return;
    }

    // JSDOM and some elements don't implement scrollTo
    element.scrollTop = top;
}

export function useScrollToAnchor ({
    containerRef,
    targetRef,
    offset = 0,
    behavior = 'smooth'
}) {
    return useCallback(() => {
        requestAnimationFrame(() => {
            const container = containerRef?.current;
            const target = targetRef?.current;
            if (!container || !target) {
                return;
            }

            const containerRect = container.getBoundingClientRect();
            const targetRect = target.getBoundingClientRect();

            const top = container.scrollTop + (targetRect.top - containerRect.top) + offset;
            safeScrollTo(container, top, behavior);
        });
    }, [behavior, containerRef, offset, targetRef]);
}
